/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_ScheduleInputs */

const en_platform_team_schedule = /** @type {(inputs: Platform_Team_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared schedule`)
};

const pl_platform_team_schedule = /** @type {(inputs: Platform_Team_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wspólny grafik`)
};

/**
* | output |
* | --- |
* | "Shared schedule" |
*
* @param {Platform_Team_ScheduleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_schedule = /** @type {((inputs?: Platform_Team_ScheduleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_ScheduleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_schedule(inputs)
	return en_platform_team_schedule(inputs)
});